import { type ComponentProps } from 'react';

import { type Alert } from '../../../../../atoms';
import { type DatasetsDataFreshnessStatus } from '../../DataFreshnessWidget.types';

export const alertVariantMap: Record<
  NonNullable<DatasetsDataFreshnessStatus>,
  ComponentProps<typeof Alert>['variant']
> = {
  all_datasets_new: 'success',
  all_datasets_old: 'destructive',
  some_datasets_old: 'destructive',
};
